import { render, staticRenderFns } from "./KanbanView.vue?vue&type=template&id=23ba3598"
import script from "./KanbanView.vue?vue&type=script&lang=js"
export * from "./KanbanView.vue?vue&type=script&lang=js"
import style0 from "./KanbanView.vue?vue&type=style&index=0&id=23ba3598&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports